export default {
  schedule: {
    date_and_time: 'Data i godzina*',
    number_of_guests: 'Liczba gości*',
    location: 'Lokalizacja:',
  },
  personal_information: {
    title: 'Tytuł',
    first_name: 'Imię',
    enter_first_name: 'Wprowadź imię',
    last_name: 'Nazwisko*',
    enter_last_name: 'Wprowadź nazwisko',
    email: 'E-mail',
    enter_email: 'Wprowadź e-mail',
    phone: 'Telefon',
    annotation: 'Adnotacja',
    enter_annotation: 'Wprowadź adnotację',
  },
  gender: {
    without_title: 'Bez tytułu',
    male: 'Pan',
    female: 'Pani',
  },
  buttons: {
    save: 'Zapisz',
  },
  error_messages: {
    invalid_email:
      'Wprowadź prawidłowy adres e-mail, bez spacji i polskich znaków diakrytycznych ani umlautów przed znakiem @.',
    invalid_phone_number: 'Nieprawidłowy numer telefonu. Sprawdź dane i spróbuj ponownie.',
    failed_reservation: 'Nie udało się przesłać rezerwacji. Sprawdź dane i spróbuj ponownie.',
    invalid_reservation_day: 'W tym dniu nie przyjmujemy rezerwacji.',
    no_tables_available: 'Przepraszamy, nie mamy już wolnych stolików.',
    please_enter_guests: 'Podaj liczbę gości.',
    please_select_time: 'Wybierz godzinę.',
    please_select_last_name: 'Podaj nazwisko',
  },
  success_messages: {
    reservation_saved: 'Rezerwacja zapisana pomyślnie',
  },
};
